import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import GradientBtn from "@ui/GradientBtn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
// styling
import styles from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import api from "@utils/api";

const tiers = [
  {
    title: "Pre Launch Rewards",
    subheader: "Double Credits Double Rewards",
    price: "$20",
    duration: "",
    description: [
      "Get Double Credits to Kickstart Your Story",
      "Exclusive Early Access to the UE COMIX Platform",
      "Custom Limited-Edition Digital Avatars",
      "VIP Community Status",
      "Private Community Hangouts",
      "Early Bird Discount on Premium Subscriptions",
      "Priority Customer Support",
    ],
    buttonText: "Get started",
    buttonVariant: "contained",
    buttonLink: "/signup",
  },
  {
    title: "Pro Creator",
    subheader: "Coming Soon",
    price: "",
    duration: "",
    description: [
      "Webcomics, Graphic Novels and Comics Creation",
      "Versatile Templates & Interactive Panels",
      "Collaborative Opportunities",
      "Priorty Support",
      "Marketing Boost & Creative Workshops",
    ],
    buttonText: "Coming Soon",
    buttonVariant: "outlined",
    buttonLink: "",
  },

  {
    title: "Master Artist",
    subheader: "Coming Soon",
    duration: "",
    // price: '$30/mo',
    description: [
      "Everything in the Procreator Pack plus:",
      "Unlimited Access to all executive features, assets, and tools",
      "VIP Community Engagement",
      "Priority Exhibition",
      "Monetization Opportunities",
    ],
    buttonText: "Coming Soon",
    buttonVariant: "outlined",
    buttonLink: "",
  },
];

const defaultTheme = createTheme();

export default function PriceAndSell() {
  const navigate = useNavigate()
  const token = localStorage.getItem("token");

  const handleClaimSubmission = () => {
    const response = api
      .post(
        `${process.env.REACT_APP_BACKEND_URL2}/initiate-payment-link`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        console.log("RES", res);
        window.open(res.data.url)
      });
  };
  const handlePayment = (buttonText) => {
    console.log(buttonText)
    if (buttonText === "Get started") {
      handleClaimSubmission()
    } else {
      console.log("do nothing");
    }
  };
  return (
    <ThemeProvider theme={defaultTheme}>
      <section className={styles.section}>
        <div className={`${styles.container} container`}>
          <h1 className={styles.heading}>Pricing</h1>
        </div>
      </section>
      <Container maxWidth="lg" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {tiers.map((tier) => (
            <Grid
              item
              key={tier.title}
              xs={12}
              sm={tier.title === "Enterprise" ? 12 : 6}
              md={4}
            >
              <Card
                sx={{
                  backgroundColor: "#161616",

                  color: "white",
                  padding: "10px 20px 30px 20px",
                  borderRadius: "10px",
                }}
              >
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{
                    align: "center",
                    style: {
                      fontWeight: "500",
                      fontSize: "26px",
                    },
                  }}
                  subheaderTypographyProps={{
                    align: "center",
                    paddingTop: "10px",
                    color: "#929292",
                  }}
                  sx={{
                    color: "#fdb808",
                  }}
                />
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "baseline",
                      mb: 2,
                      backgroundColor: "#161616",
                      color: "white",
                    }}
                  >
                    <Typography
                      component="h2"
                      variant="h4"
                      color="white"
                      style={{ fontWeight: 700 }}
                    >
                      {tier.price}
                    </Typography>
                    <Typography variant="h6" color="white">
                      {tier.price ? "" + tier.duration : null}
                    </Typography>
                  </Box>
                  <ul>
                    {tier.description.map((line) => (
                      <Typography
                        component="li"
                        key={line}
                        color="#969696"
                        sx={{
                          paddingBottom: "15px",
                          fontSize: "1.2rem",
                        }}
                      >
                        <FontAwesomeIcon icon={faCircleCheck} size="sm" />
                        &nbsp;{line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <div className={styles.btn}>
                  <GradientBtn
                    onClick={()=>handlePayment(tier.buttonText)}
                    href={tier.buttonLink}
                    disabled={tier.buttonText === "Coming Soon"}
                  >
                    {tier.buttonText}
                  </GradientBtn>
                </div>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ThemeProvider>
  );
}
